import UIStrings from '@/Utils/UIStrings';

function EmailVerifiedPageContentTypography() {
    return (
        <div className="flex flex-col items-center gap-2 text-center">
            <h1 className="text-foreground text-2xl font-semibold tracking-tight md:text-3xl">
                {UIStrings.YourEmailHasBeenVerified}
            </h1>
            <p className="text-foreground text-sm md:text-base">{UIStrings.YouCanNowLoginToTalentMesh}</p>
        </div>
    );
}

export default EmailVerifiedPageContentTypography;
